import { UrlConfig } from '@shared/config/url.config';

export class ConfigurableMessageConfig {
    private static configurableMessage: string = UrlConfig.urlAdmin + 'configurable-messages';

    public static configurableMessageList(sourceCode: string): string {
        return `${this.configurableMessage}/sources/${encodeURIComponent(sourceCode)}/actifs`;
    }
}